import { Select } from 'antd';
import CSS from 'csstype';
import React, { useContext } from 'react';

import { Context } from 'components/hoc/Store';

import useProfily from 'hooks/useProfily';

import czflag from 'styles/images/cz_flag.png';
import ukflag from 'styles/images/uk_flag.png';

const { Option } = Select;

export interface ISelectData {
    value: string | number;
    labelcz: string;
    labelen?: string;
}

interface ISelect {
    placeholder?: string;
    disabled?: boolean;
    style?: CSS.Properties;
    mode?: 'multiple' | 'tags';
    showSearch?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    filterOption?: (input: any, option: any) => boolean;
    showOptionValue?: boolean;
    optionValueFilter?: string[];
}

const LanguageSelect: React.FC<ISelect> = ({ disabled, mode, style, ...rest }) => {
    const { language } = useContext(Context);
    // const { navigateWorkaround } = useNavigateWorkaround();
    const { setLevel } = useProfily();

    return (
        <Select
            className="lang-select"
            style={{
                width: '46px',
                ...style
            }}
            showArrow={false}
            mode={mode}
            onChange={val => {
                setLevel('language', val);
                window.location.replace(`${window.location.href.split('?')[0]}?lang=${val}`);
            }}
            disabled={disabled}
            value={language}
            popupClassName={'langDropDown'}
            {...rest}
        >
            <Option
                className="select-option-component"
                value="cz"
                style={{
                    padding: 0
                }}
            >
                <input
                    type="image"
                    alt="czflag"
                    src={czflag}
                    width="22px"
                    style={{
                        position: 'relative',
                        top: 4.5,
                        right: 0
                    }}
                />
            </Option>
            <Option
                className="select-option-component"
                value="en"
                style={{
                    padding: 0
                }}
            >
                <input
                    type="image"
                    alt="ukflag"
                    src={ukflag}
                    width="22px"
                    style={{
                        position: 'relative',
                        top: 4.5,
                        right: 0
                    }}
                />
            </Option>
        </Select>
    );
};

export default LanguageSelect;
